export const newsItems = [
  {
    id: 1,
    slug: 'huisheni-taarifa-kwenye-tovuti-zenu',
    image: '/assets/img/miradi.jpg',
    title: 'Huisheni Taarifa Kwenye Tovuti Zenu',
    date: '10 November 2025',
    summary: 'Uwazi na taarifa sahihi mtandaoni huongeza uaminifu wa wananchi na uwekezaji wa utafiti.',
    content: [
      'COSTECH imezindua mwongozo mpya wa kuhakikisha taarifa zote muhimu za utafiti na uvumbuzi zinapatikana mtandaoni bila vikwazo. Hatua hii inalenga kuongeza uwazi na kusaidia wadau kupata taarifa kwa wakati.',
      'Kwa kuimarisha usimamizi wa taarifa mtandaoni, taasisi za serikali na sekta binafsi zitaweza kuwafikia wananchi wengi zaidi, kuongeza uwekezaji na kutengeneza mazingira bora ya ushirikiano wa kimataifa.',
      'Mwongozo huu unasisitiza matumizi ya mifumo ya kidijitali, usalama wa taarifa, na ufuatiliaji wa mara kwa mara ili kuhakikisha ubora wa taarifa zinazochapishwa.'
    ]
  },
  {
    id: 2,
    slug: 'matumizi-ya-mifumo-ya-tehama',
    image: '/assets/img/hero2.jpeg',
    title: 'MATUMIZI YA MIFUMO YA TEHAMA YAMEIMARISHA UWAZI NA UFANISI SERIKALINI.',
    date: '05 November 2025',
    summary: 'Serikali yaendelea kusimamia mifumo ya kidijitali kwa uwazi, uwajibikaji na utoaji wa huduma bora.',
    content: [
      'Katika mkutano uliofanyika jijini Dodoma, COSTECH imeonyesha mafanikio ya mageuzi ya TEHAMA ndani ya serikali na taasisi zake. Mifumo mipya imesaidia kupunguza muda wa utoaji wa huduma na kuongeza uthibitisho wa nyaraka kwa njia ya kidijitali.',
      'Imebainika kuwa mafunzo ya mara kwa mara kwa watumishi wa umma na uwekezaji katika miundombinu ya TEHAMA umeleta matokeo chanya kwenye utoaji huduma za serikali mtandao.',
      'Wananchi sasa wana uwezo wa kupata taarifa na huduma muhimu za kiserikali kupitia majukwaa ya mtandaoni bila kulazimika kufika ofisini.'
    ]
  },
  {
    id: 3,
    slug: 'utafiti-na-ubunifu-wa-teknolojia-tanzania',
    image: '/assets/img/hero.jpg',
    title: 'Utafiti na Ubunifu wa Teknolojia Tanzania',
    date: '28 October 2025',
    summary: 'Miradi mipya ya ubunifu inaendelea kuletwa kwa ajili ya maendeleo ya taifa na uchumi wa kidijitali.',
    content: [
      'Wasomi wa ndani na nje ya nchi wamewasilisha matokeo ya tafiti mpya zinazojikita katika nishati jadidifu, kilimo kidijitali na huduma za afya mtandao. COSTECH imeahidi kuunga mkono tafiti hizi kwa ruzuku na ushirikiano wa kimataifa.',
      'Miradi iliyowasilishwa imeonyesha jinsi matumizi ya data kubwa na akili bandia yanavyoweza kuongeza ufanisi katika sekta za kilimo na afya.',
      'Wanunuzi wa teknolojia na wajasiriamali walipewa nafasi ya kuwasilisha bidhaa zao na kutafuta washirika wa uwekezaji.'
    ]
  },
  {
    id: 4,
    slug: 'wanawake-viongozi-waongoza-mageuzi-ya-tehama',
    image: '/assets/img/hero2.jpeg',
    title: 'Wanawake Viongozi Waongoza Mageuzi ya TEHAMA',
    date: '18 October 2025',
    summary: 'Viongozi wanawake watoa maoni kuhusu umuhimu wa ushiriki wa wanawake katika sekta ya sayansi na teknolojia.',
    content: [
      'Katika mdahalo wa kitaifa, viongozi wanawake walizungumzia nafasi yao katika kuharakisha mageuzi ya TEHAMA nchini Tanzania. Walisisitiza umuhimu wa programu za kumtayarisha msichana katika sayansi, teknolojia, uhandisi na hisabati (STEM).',
      'COSTECH inaendelea kuwekeza katika miradi ya kuhamasisha ushiriki wa wasichana kwenye klabu za ubunifu na mashindano ya kidijitali.',
      'Mdahalo ulihitimishwa kwa mipango ya ushirikiano na sekta binafsi ili kutoa mafunzo kwa vitendo na uhamasishaji wa wake wanaofanya kazi katika TEHAMA.'
    ]
  },
  {
    id: 5,
    slug: 'tanzania-yazindua-mkakati-wa-ubunifu-wa-kitaifa',
    image: '/assets/img/miradi.jpg',
    title: 'Tanzania Yazindua Mkakati wa Ubunifu wa Kitaifa',
    date: '02 October 2025',
    summary: 'Mkakati mpya unalenga kuimarisha mazingira wezeshi kwa wajasiriamali wa teknolojia nchini.',
    content: [
      'Mkakati wa Ubunifu wa Kitaifa umewekwa ili kuwezesha wajasiriamali wa teknolojia kupata mitaji, masoko na rasilimali za kimaabara. COSTECH kwa kushirikiana na wizara husika, imeandaa mipango ya mafunzo na mashindano ya ubunifu.',
      'Mkakati huu unalenga kuongeza idadi ya bidhaa za teknolojia zinazotengenezwa ndani ya nchi na kusajiliwa kwa hakimiliki.',
      'Serikali imeahidi kupunguza vikwazo vya udhibiti na utekelezaji wa sera rafiki kwa ubunifu kupitia vituo vya huduma kwa wajasiriamali.'
    ]
  },
  {
    id: 6,
    slug: 'makampuni-ya-teknolojia-kushirikiana-na-costech',
    image: '/assets/img/hero.jpg',
    title: 'Makampuni ya Teknolojia Kushirikiana na COSTECH',
    date: '15 September 2025',
    summary: 'Makubaliano mapya ya ushirikiano yanalenga kukuza tafiti zinazosaidia huduma za kijamii zinazoendeshwa na data.',
    content: [
      'Makampuni makubwa ya teknolojia yamesaini makubaliano na COSTECH kufadhili tafiti zinazohusiana na miundombinu ya data, usalama mtandao na huduma bunifu za jamii.',
      'Kwa kushirikiana, wataalam watatoa mafunzo kwa watafiti chipukizi na kuanzisha kambi za ubunifu (innovation labs) katika vyuo vikuu mbalimbali.',
      'Makubaliano haya yanajumuisha pia utoaji wa vifaa vya maabara na bima ya kitaaluma kwa watafiti wanaohusika.'
    ]
  }
];


